module.exports = __webpack_public_path__ + "img/iPay.560c0686.png";